/**
 * @generated SignedSource<<fe0bec4e206a3b46a3d580f49a3bbef9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_deliveryOptions" | "useFDFQuoteVariant_deliveryOptions">;
  readonly " $fragmentType": "CheckoutLayout_deliveryOptions";
}>;
export type CheckoutLayout_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutLayout_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutLayout_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFDFQuoteVariant_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "47a50dff23a74fc19c9b20824f12b3db";

export default node;
